<div class="page-container">
    <!-- <div class="page-header" *ngIf="currentCompany">{{currentCompany.name}} Client Admin page</div>
    <div class="page-header" *ngIf="!currentCompany">Client Admin page</div> -->
    <!-- <div class="page-header">Client Admin page</div> -->
    <div class="page-header">{{currentCompany}} Super Admin page</div>
    
    <div style="display: flex; align-items: center; justify-content: space-between; width: 100%; margin-left: 8px;">
        <nav mat-tab-nav-bar>
            <a mat-tab-link
               *ngFor="let link of navLinks"
               [routerLink]="link.link"
               routerLinkActive #rla="routerLinkActive"
               [active]="rla.isActive"
               (click)="updateActiveLinkIndex(link.index)">
                {{link.label}}
            </a>
        </nav>
        <!-- <span readOnly [hide]="true">
            <button *ngIf="activeLinkIndex == 1 || activeLinkIndex == -1"
            mat-flat-button color="primary" style="margin-right: 10px;"
            >Add User</button>
        </span> -->
    </div>
    <router-outlet></router-outlet>
    <!-- <div class="loading-wrapper-top">
        <mat-spinner diameter="30" *ngIf="zones.length === 0"></mat-spinner>
    </div> -->
</div>